import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class BenefitCreatedEvent extends EventV2<{ claimId: number }> {}
